import { writable, get } from 'svelte/store';

import { formatTraceParent } from '../services/SessionTraceUtils.js';

// store session trace id
export const traceId =  writable([]);

// return formatted traceparent string
export function getTraceParent (parentId) {
    console.log({parentId});
    return formatTraceParent(get(traceId), parentId);
}

